import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-m-5"
}
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-my-4" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "kn-flex" }
const _hoisted_9 = { class: "p-d-flex p-jc-between" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "startDate",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "endDate",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withCtx(() => [
      (_ctx.target)
        ? (_openBlock(), _createBlock("form", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_InputText, _mergeProps(_ctx.$attrs, {
                  id: "name",
                  class: ["kn-material-input", {
                                'p-invalid': _ctx.vcomp.name.$invalid && _ctx.vcomp.name.$dirty
                            }],
                  type: "text",
                  maxLength: "100",
                  modelValue: _ctx.target.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.target.name = $event)),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.valueChanged('name', $event.target.value))),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vcomp.name.$touch()))
                }), null, 16, ["modelValue", "class"]),
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('kpi.targetDefinition.name')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.vcomp.name,
                additionalTranslateParams: { fieldName: _ctx.$t('kpi.targetDefinition.name') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_AutoComplete, {
                  id: "category",
                  modelValue: _ctx.target.category,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.target.category = $event)),
                  suggestions: _ctx.filteredCategory,
                  onComplete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchCategory($event))),
                  field: "valueName",
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.valueChanged('category', $event.target.value))),
                  onItemSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.valueChanged('category', $event.value)))
                }, null, 8, ["modelValue", "suggestions"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('kpi.targetDefinition.kpiCategory')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_10, [
                    _createVNode(_component_Calendar, {
                      id: "startDate",
                      class: ["kn-material-input", {
                                        'p-invalid': _ctx.vcomp.startValidity.$invalid && _ctx.vcomp.startValidity.$dirty
                                    }],
                      modelValue: _ctx.target.startValidity,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.target.startValidity = $event)),
                      onDateSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.valueChanged('startValidity', $event))),
                      showIcon: true,
                      manualInput: false,
                      onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.vcomp.startValidity.$touch()))
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('kpi.targetDefinition.startDate')) + " * ", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    vComp: _ctx.vcomp.startValidity,
                    additionalTranslateParams: { fieldName: _ctx.$t('kpi.targetDefinition.startDate') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_13, [
                      _createVNode(_component_Calendar, {
                        id: "endDate",
                        class: ["kn-material-input", {
                                            'p-invalid': _ctx.vcomp.endValidity.$invalid && _ctx.vcomp.endValidity.$dirty
                                        }],
                        modelValue: _ctx.target.endValidity,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.target.endValidity = $event)),
                        onDateSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.valueChanged('endValidity', $event))),
                        showIcon: true,
                        manualInput: false,
                        onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.vcomp.endValidity.$touch()))
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('kpi.targetDefinition.endDate')) + " * ", 1)
                    ]),
                    _createVNode(_component_KnValidationMessages, {
                      vComp: _ctx.vcomp.endValidity,
                      additionalTranslateParams: { fieldName: _ctx.$t('kpi.targetDefinition.endDate') },
                      specificTranslateKeys: { is_after_date: 'kpi.targetDefinition.endDateBeforeStart' }
                    }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}